import React from 'react';

const GermanRegistryInfo: React.FC = () => {
  return (
    <div className="flex items-center justify-center gap-3 max-w-xl mx-auto px-4 my-8">
      <div className="flex-shrink-0">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 5 3" 
          className="w-8 h-auto"
          style={{ 
            border: '1px solid #eaeaea',
            borderRadius: '4px',
            overflow: 'hidden'
          }}
        >
          <rect width="5" height="3" fill="#000"/>
          <rect width="5" height="2" y="1" fill="#D00"/>
          <rect width="5" height="1" y="2" fill="#FFCE00"/>
        </svg>
      </div>
      <span
        style={{
          color: '#000',
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.35,
          WebkitFontSmoothing: 'antialiased',
          wordBreak: 'break-word',
          hyphens: 'initial',
          WebkitTapHighlightColor: 'transparent',
          letterSpacing: 'normal',
          textAlign: 'center'
        }}
      >
        Sie erhalten die zuverlässige Adressauskunft direkt aus den Registern der zuständigen Einwohnermeldeämter.
      </span>
    </div>
  );
};

export default GermanRegistryInfo; 